module.exports = __webpack_public_path__ + "assets/img/headPortrait.c2d5a5d7.png";